<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_v">C<span class="smallcaps">ONTENTS</span></a></h1><a id="page_v">
<table border="0" cellpadding="3" cellspacing="0" width="100%">
<colgroup><col width="10%"/>
<col width="90%"/>
</colgroup><tbody>
<tr>
<td align="left" colspan="2"><a href="#/006_Preface#fm-1">Preface</a></td>
</tr>
<tr>
<td align="right"><a href="#/007_Chapter01#ch-1">I.</a></td>
<td align="left"><a href="#/007_Chapter01#ch-1">Two Cities Called Chicago</a></td>
</tr>
<tr>
<td align="right"><a href="#/008_Chapter02#ch-2">II.</a></td>
<td align="left"><a href="#/008_Chapter02#ch-2">Read All About It: The Official Story Emerges</a></td>
</tr>
<tr>
<td align="right"><span href="#/009_Chapter03#ch-3" title="Link target outside of Sample">III.</span></td>
<td align="left"><span href="#/009_Chapter03#ch-3" title="Link target outside of Sample">The Police in Action</span></td>
</tr>
<tr>
<td align="right"><span href="#/010_Chapter04#ch-4" title="Link target outside of Sample">IV.</span></td>
<td align="left"><span href="#/010_Chapter04#ch-4" title="Link target outside of Sample">The Usual Sustpects: Stirrings on the Left Wing</span></td>
</tr>
<tr>
<td align="right"><span href="#/011_Chapter05#ch-5" title="Link target outside of Sample">V.</span></td>
<td align="left"><span href="#/011_Chapter05#ch-5" title="Link target outside of Sample">No Room for Neutrality: The Jewish Community Reacts</span></td>
</tr>
<tr>
<td align="right"><span href="#/012_Chapter06#ch-6" title="Link target outside of Sample">VI.</span></td>
<td align="left"><span href="#/012_Chapter06#ch-6" title="Link target outside of Sample">The Fight for Control of the Story</span></td>
</tr>
<tr>
<td align="right"><span href="#/013_Chapter07#ch-7" title="Link target outside of Sample">VII.</span></td>
<td align="left"><span href="#/013_Chapter07#ch-7" title="Link target outside of Sample">The Fight Continues: Tug-of-War Over Averbuch’s Body</span></td>
</tr>
<tr>
<td align="right"><span href="#/014_Chapter08#ch-8" title="Link target outside of Sample">VIII.</span></td>
<td align="left"><span href="#/014_Chapter08#ch-8" title="Link target outside of Sample">Repercussions</span></td>
</tr>
<tr>
<td align="right"><span href="#/015_Chapter09#ch-9" title="Link target outside of Sample">IX.</span></td>
<td align="left"><span href="#/015_Chapter09#ch-9" title="Link target outside of Sample">The Affair Goes National: Congress Quarrels and Emma Finds a Lover</span></td>
</tr>
<tr>
<td align="right"><span href="#/016_Chapter10#ch-10" title="Link target outside of Sample">X.</span></td>
<td align="left"><span href="#/016_Chapter10#ch-10" title="Link target outside of Sample">The Inquest</span></td>
</tr>
<tr>
<td align="right"><span href="#/017_Chapter11#ch-11" title="Link target outside of Sample">XI.</span></td>
<td align="left"><span href="#/017_Chapter11#ch-11" title="Link target outside of Sample">Making Sense of It All: Theories Abound</span></td>
</tr>
<tr>
<td align="left" colspan="2"><span href="#/018_Afterword#bm-1" title="Link target outside of Sample">Afterword</span></td>
</tr>
<tr>
<td align="left" colspan="2"> </td>
</tr>
<tr>
<td align="left" colspan="2"><span href="#/019_Endnotes#bm-2" title="Link target outside of Sample">Endnotes</span></td>
</tr>
<tr>
<td align="left" colspan="2"><span href="#/020_Bibliography#bm-3" title="Link target outside of Sample">Bibliography</span></td>
</tr>
<tr>
<td align="left" colspan="2">Index</td>
</tr>
<tr>
<td align="left" colspan="2">Index of Newspapers and Magazines</td>
</tr>
<tr>
<td align="left" colspan="2"><span href="#/021_Abouttheauthors#bm-4" title="Link target outside of Sample">About the Authors</span></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Contents.vue?44a342f7